import { Injectable } from '@angular/core';
import { IndexedDBServiceBase } from '@shared/service/Indexeddb/IndexedDBServiceBase';

@Injectable()
export class IndexedDBService extends IndexedDBServiceBase {
    public constructor() {
        super();
    }
}
